// frontend/src/components/ColorsTab.js

const COLOR_LABELS = {
  primary: "Primary",
  secondary: "Secondary",
  accentOrange: "Accent Orange",
  accentTerracotta: "Accent Terracotta",
  accentSky: "Accent Sky",
  leadline: "Leadline",
  backgroundClear: "Background Clear",
  backgroundFrosted: "Background Frosted",
  textDark: "Text Dark",
};

function ColorsTab({ config, onChange }) {
  const updateColor = (key, value) => {
    const next = JSON.parse(JSON.stringify(config));
    next.colors[key] = value.toUpperCase();
    onChange(next);
  };

  return (
    <div className="leadline-border overflow-hidden bg-[#F5EDE0]">
      <div className="px-4 py-2 text-sm font-medium text-white" style={{ backgroundColor: config.colors.primary }}>
        Color Palette
      </div>
      <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {Object.entries(COLOR_LABELS).map(([key, label]) => (
          <label key={key} className="block">
            <span className="block text-xs mb-1 text-[#3A3530]">{label}</span>
            <div className="flex items-center gap-2">
              <input
                type="color"
                value={config.colors[key]}
                onChange={(e) => updateColor(key, e.target.value)}
                className="h-8 w-10 p-0 border-0 bg-transparent cursor-pointer"
              />
              <input
                value={config.colors[key]}
                onChange={(e) => updateColor(key, e.target.value)}
                className="w-full leadline-border-thin px-2 py-1 bg-white text-sm"
              />
            </div>
          </label>
        ))}
      </div>
    </div>
  );
}

export default ColorsTab;
